import React from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

const LOCATIONS = [
  { city: 'Phoenix', path: '/phoenix-power-washing' },
  { city: 'Scottsdale', path: '/scottsdale-power-washing' },
  { city: 'Mesa', path: '/mesa-power-washing' },
  { city: 'Tempe', path: '/tempe-power-washing' },
  { city: 'Gilbert', path: '/gilbert-power-washing' },
  { city: 'Paradise Valley', path: '/paradise-valley-power-washing' },
];

function Footer() {
  return (
    <footer className="bg-[#f8f7f3] border-t border-gray-200 mt-12 py-10 px-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
        <div className="flex flex-col items-center md:items-start mb-8 md:mb-0">
          <picture>
            <source srcSet="/Copper Canyon Pressure Wash_final logo.avif" type="image/avif" />
            <source srcSet="/Copper Canyon Pressure Wash_final logo.webp" type="image/webp" />
          <img
            src="/Copper Canyon Pressure Wash_final logo.png"
            alt="Copper Canyon Pressure Wash Logo"
              title="Copper Canyon Pressure Wash - Professional Pressure Washing Services"
            className="h-24 w-auto mb-4"
              width="300"
              height="96"
              loading="lazy"
          />
          </picture>
          <span className="text-[#4a3f35] font-bold text-lg">Copper Canyon Pressure Wash</span>
        </div>
        <div className="flex flex-col md:flex-row gap-8 w-full md:w-auto justify-between">
          <div>
            <h2 className="text-[#8B4513] font-semibold mb-2">Pages</h2>
            <ul className="space-y-1">
              <li><Link to="/" className="hover:text-[#b87c4c]">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#b87c4c]">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#b87c4c]">Contact</Link></li>
              <li><Link to="/residential" className="hover:text-[#b87c4c]">Residential</Link></li>
              <li><Link to="/commercial" className="hover:text-[#b87c4c]">Commercial</Link></li>
              <li><Link to="/pricing" className="hover:text-[#b87c4c]">Pricing</Link></li>
              <li><Link to="/blog" className="hover:text-[#b87c4c]">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h2 className="text-[#8B4513] font-semibold mb-2">Services</h2>
            <ul className="space-y-1">
              <li><Link to="/driveway-cleaning" className="hover:text-[#b87c4c]">Driveway Cleaning</Link></li>
              <li><Link to="/solar-panel-cleaning" className="hover:text-[#b87c4c]">Solar Panel Cleaning</Link></li>
              <li><Link to="/pool-deck-cleaning" className="hover:text-[#b87c4c]">Pool Deck Cleaning</Link></li>
              <li><Link to="/patio-cleaning" className="hover:text-[#b87c4c]">Patio Cleaning</Link></li>
              <li><Link to="/commercial-concrete-cleaning" className="hover:text-[#b87c4c]">Commercial Concrete Cleaning</Link></li>
              <li><Link to="/graffiti-removal" className="hover:text-[#b87c4c]">Graffiti Removal</Link></li>
              <li><Link to="/window-cleaning" className="hover:text-[#b87c4c]">Window Cleaning</Link></li>
              <li><Link to="/gutter-cleaning" className="hover:text-[#b87c4c]">Gutter Cleaning</Link></li>
              <li><Link to="/sidewalk-cleaning" className="hover:text-[#b87c4c]">Sidewalk Cleaning</Link></li>
              <li><Link to="/deck-cleaning" className="hover:text-[#b87c4c]">Deck Cleaning</Link></li>
              <li><Link to="/fence-cleaning" className="hover:text-[#b87c4c]">Fence Cleaning</Link></li>
              <li><NavLink to="/pressure-washing" className="hover:text-[#b87c4c]">Pressure Washing</NavLink></li>
            </ul>
          </div>
          <div>
            <h2 className="text-[#8B4513] font-semibold mb-2">Locations</h2>
            <ul className="space-y-1">
              {LOCATIONS.map(loc => (
                <li key={loc.city}><Link to={loc.path} className="hover:text-[#b87c4c]">{loc.city}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="text-center text-[#4a3f35] text-sm mt-8">&copy; {new Date().getFullYear()} Copper Canyon Pressure Wash. All rights reserved.</div>
    </footer>
  );
}

export default Footer; 